<template>
  <div class="wrapper">
    <div class="clist">
      <div class="ctop" @click="btn(1)">
        <van-icon name="gold-coin" size="40px" />
        <p>押金充值</p>
        <img src="@/assets/appointment/xsj_r.png" class="yybtn_cl">
      </div>
      <div @click="btn(2)">
        <van-icon name="balance-list" size="40px" />
        <p>充值记录</p>
        <img src="@/assets/appointment/xsj_r.png" class="yybtn_cl">
      </div>
    </div>
    <judgment></judgment>
  </div>
</template>

<script>
import Judgment from "@/components/Judgment/Judgment.vue";
export default {
  components: {
    Judgment
  },
  data(){
    return{
      
    }
  },
  methods: {
    btn(num){
      if(num == 1){
        this.$router.push("/Recharge");
      }else if(num == 2){
        this.$router.push("/RechargeRecord");
      }
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  .clist{
    margin: 12px;
    border-radius: 10px;
    background: white;
    >div {
      padding: 10px;
      display: flex;
      align-items: center;
      >p{
        font-size: 20px;
        margin-left: 10px;
      }
    }
    .ctop{
      border-bottom: 1px solid #ddd;
    }
    .yybtn_cl{
      position: relative;
      left: 180px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/Deposit/OutpatientDeposit.vue